import cookie from "react-cookies";
import constants from "../Constants";

const baseURL = constants.baseURL;

const authHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = cookie.load("candidateKey");
  if (token) headers.Authorization = token;
  return headers;
};

export async function academyFetch(path, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
    const res = await fetch(`${baseURL}${path}`, {
      ...options,
      signal: controller.signal,
      headers: { ...authHeaders(), ...options.headers },
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Request failed");
    return data;
  } finally {
    clearTimeout(timeout);
  }
}

export const getAcademyCatalog = () => academyFetch("/academy/catalog");
export const getAcademyHome = () => academyFetch("/academy/home");
export const getAcademyDetail = (slug) => academyFetch(`/academy/academies/${slug}`);
export const getAcademyModule = (moduleSlug, academySlug) =>
  academyFetch(
    academySlug
      ? `/academy/academies/${academySlug}/modules/${moduleSlug}`
      : `/academy/modules/${moduleSlug}`
  );
export const postAcademyProgress = (body) =>
  academyFetch("/academy/progress", { method: "POST", body: JSON.stringify(body) });
export const postAcademyEvents = (events) =>
  academyFetch("/academy/events", {
    method: "POST",
    body: JSON.stringify({ events: Array.isArray(events) ? events : [events] }),
  });
export const getAcademyQuiz = (quizId) => academyFetch(`/academy/quiz/${quizId}`);
export const submitAcademyQuiz = (quizId, answers) =>
  academyFetch(`/academy/quiz/${quizId}/submit`, {
    method: "POST",
    body: JSON.stringify({ answers }),
  });
export const getAcademyMe = () => academyFetch("/academy/me");

export const getLiveShiftInvites = () => academyFetch("/academy/interview-days");
export const rsvpLiveShift = (inviteId, status) =>
  academyFetch(`/academy/interview-days/${inviteId}/rsvp`, {
    method: "POST",
    body: JSON.stringify({ status }),
  });

export const getAcademyCertificates = () => academyFetch("/academy/certificates");
export const getCertificationEligibility = (academy) =>
  academyFetch(`/academy/certifications/eligibility${academy ? `?academy=${encodeURIComponent(academy)}` : ""}`);
export const extractCertificate = (id) =>
  academyFetch(`/academy/certificates/${id}/extract`, { method: "POST" });
export const verifyCertificate = (number) =>
  fetch(`${baseURL}/academy/certificates/verify/${encodeURIComponent(number)}`).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Verification failed");
    return data;
  });

export const getCandidateProfile = () => academyFetch("/academy/profile");
export const patchCandidateProfile = (body) =>
  academyFetch("/academy/profile", { method: "PATCH", body: JSON.stringify(body) });
export const requestQualificationUpload = (body) =>
  academyFetch("/academy/qualifications/upload-url", { method: "POST", body: JSON.stringify(body) });
export const confirmQualificationUpload = (body) =>
  academyFetch("/academy/qualifications/confirm", { method: "POST", body: JSON.stringify(body) });
export const deleteQualification = (id) =>
  academyFetch(`/academy/qualifications/${id}`, { method: "DELETE" });

export const postCandidateOtp = (email, recaptcha) =>
  fetch(`${baseURL}/candidate-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, "g-recaptcha-response": recaptcha }),
  });

export const validateCandidateOtp = (email, otp) =>
  fetch(`${baseURL}/validate-candidate-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp }),
  });

export const getCareersPublicStats = () =>
  fetch(`${baseURL}/careers/public-stats`).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Failed to load stats");
    return data;
  });
